import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import Logo from "@/components/Logo";

const DOCS = {
  kvkk: {
    title: "KVKK Aydınlatma Metni",
    body: [
      ["Veri Sorumlusu", "Get Up Fit, 6698 sayılı Kişisel Verilerin Korunması Kanunu (\"KVKK\") kapsamında veri sorumlusu sıfatıyla hareket eder."],
      ["İşlenen Veriler", "Ad soyad, e-posta, telefon numarası, şube tercihi, doğum tarihi, cinsiyet ve ölçüm/antrenman kayıtları gibi üyelik bilgileriniz işlenir."],
      ["İşleme Amaçları", "Üyelik yönetimi, randevu ve paket takibi, ödeme işlemleri, bilgilendirme ve pazarlama (açık rızanız dahilinde) amaçlarıyla verileriniz işlenir."],
      ["Aktarım", "Verileriniz yalnızca hizmetin yürütülmesi için gerekli tedarikçilerle (ör. e-posta/WhatsApp servis sağlayıcıları) ve yasal yükümlülükler kapsamında yetkili kurumlarla paylaşılabilir."],
      ["Haklarınız", "KVKK m.11 uyarınca verilerinize erişme, düzeltme, silme ve işlemeye itiraz etme haklarına sahipsiniz. Taleplerinizi iletişim kanallarımızdan iletebilirsiniz."],
    ],
  },
  gizlilik: {
    title: "Gizlilik Politikası",
    body: [
      ["Toplanan Bilgiler", "Hesap oluştururken ve platformu kullanırken sağladığınız bilgileri ve otomatik olarak oluşan kullanım verilerini topluyoruz."],
      ["Kullanım", "Bilgileriniz hizmeti sunmak, güvenliği sağlamak ve deneyiminizi iyileştirmek için kullanılır."],
      ["Güvenlik", "Şifreler modern hash yöntemleriyle saklanır; veriler güvenli bağlantılar üzerinden iletilir ve yetkisiz erişime karşı korunur."],
      ["Çerezler", "Oturum yönetimi ve temel işlevler için gerekli çerezler kullanılır."],
      ["İletişim", "Gizlilikle ilgili sorularınız için destek kanallarımızdan bize ulaşabilirsiniz."],
    ],
  },
  kosullar: {
    title: "Kullanım Koşulları",
    body: [
      ["Hizmet", "Get Up Fit platformu, fitness stüdyosu operasyonlarının yönetimi için sunulan bir hizmettir."],
      ["Hesap Sorumluluğu", "Hesap bilgilerinizin gizliliğinden ve hesabınız altında gerçekleşen işlemlerden siz sorumlusunuz."],
      ["Kabul Edilebilir Kullanım", "Platformu yasalara aykırı veya başkalarının haklarını ihlal edecek şekilde kullanamazsınız."],
      ["Değişiklikler", "Koşullar zaman zaman güncellenebilir; önemli değişiklikler kullanıcılara bildirilir."],
      ["Sorumluluk Sınırı", "Hizmet \"olduğu gibi\" sunulur; mevzuatın izin verdiği ölçüde dolaylı zararlardan sorumluluk kabul edilmez."],
    ],
  },
};

export default function Legal({ doc }) {
  const d = DOCS[doc] || DOCS.kvkk;
  useEffect(() => { document.title = `Get Up Fit | ${d.title}`; }, [d.title]);
  return (
    <div className="min-h-screen bg-[#0B0B0E] text-white px-4 py-10" data-testid={`legal-${doc}-page`}>
      <div className="max-w-2xl mx-auto">
        <div className="flex items-center justify-between mb-8">
          <Logo />
          <Link to="/login" data-testid="legal-back-link" className="inline-flex items-center gap-1.5 text-sm text-[#A0A0B2] hover:text-[#FF5500]">
            <ArrowLeft size={16} /> Girişe dön
          </Link>
        </div>
        <h1 className="font-display font-black text-3xl sm:text-4xl mb-2">{d.title}</h1>
        <p className="text-sm text-[#68687B] mb-8">Son güncelleme: Haziran 2026</p>
        <div className="space-y-6">
          {d.body.map(([h, p]) => (
            <section key={h}>
              <h2 className="text-lg font-bold text-[#FF5500] mb-1.5">{h}</h2>
              <p className="text-sm leading-relaxed text-[#C5C5D3]">{p}</p>
            </section>
          ))}
        </div>
      </div>
    </div>
  );
}
